import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-profile-main',
    templateUrl: './profile-main.component.html',
    styleUrls: ['./profile-main.component.scss'],
    standalone: false
})
export class ProfileMainComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
